module.exports = __webpack_public_path__ + "img/933-9362df.png";